import { createFileRoute, Navigate, redirect } from '@tanstack/react-router'
import { isSafeRedirect } from '@/lib/url-validation'
import { magicLinkErrorReasonFromDetail } from '@/lib/magic-link-error'

interface CallbackSearch {
  token?: string
  next?: string
}

export const Route = createFileRoute('/_login_forms/callback')({
  validateSearch: (search: Record<string, unknown>): CallbackSearch => ({
    token: search['token'] as string | undefined, // eslint-disable-line dot-notation
    next: search['next'] as string | undefined, // eslint-disable-line dot-notation
  }),
  beforeLoad: async ({ search, context }) => {
    const { token, next } = search

    if (!token) {
      throw redirect({ to: '/magic-link-error', search: { reason: 'invalid' } })
    }

    const user = await context.auth.magicLinkCallback(token)

    // Redirect superusers to admin portal, others to next or home
    const destination = user.is_superuser ? '/admin' : isSafeRedirect(next)
    throw redirect({ href: destination })
  },
  errorComponent: ({ error }) => {
    // The hey-api openapi-ts client (with throwOnError: true) throws the parsed
    // JSON body for non-ok responses, e.g. { detail: "..." }. It's not an Error
    // instance, so read `detail` defensively and map to a canonical reason that
    // the dedicated error page renders with friendly copy.
    const detail
      = error && typeof error === 'object' && 'detail' in error
        && typeof (error as { detail: unknown }).detail === 'string'
        ? (error as { detail: string }).detail
        : undefined
    const reason = magicLinkErrorReasonFromDetail(detail)
    return <Navigate to="/magic-link-error" search={{ reason }} />
  },
})
